import { mediaData } from '@/mocks/homeData';

const mediaImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20photography%20style%20with%20warm%20crimson%20and%20charcoal%20tones%2C%20dramatic%20atmospheric%20lighting%2C%20mysterious%20film%20noir%20aesthetic%2C%20abstract%20composition%20with%20subtle%20texture%20and%20grain%2C%20editorial%20documentary%20look%2C%20no%20people%20no%20text&width=800&height=450&seq=media-1-911&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=Warm%20amber%20and%20deep%20brown%20cinematic%20lighting%2C%20interview%20documentary%20style%20atmosphere%2C%20soft%20bokeh%20background%20with%20geometric%20shapes%2C%20sophisticated%20moody%20tone%2C%20investigative%20journalism%20aesthetic%2C%20no%20people%20no%20text&width=800&height=450&seq=media-2-911&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=Dark%20moody%20abstract%20composition%20with%20deep%20crimson%20red%20gradient%2C%20audio%20waveform%20visualization%20concept%2C%20low%20key%20lighting%20with%20warm%20glow%2C%20minimalist%20detective%20noir%20style%2C%20editorial%20photography%20mood%2C%20no%20people%20no%20text&width=800&height=450&seq=media-3-911&orientation=landscape',
  4: 'https://readdy.ai/api/search-image?query=Warm%20crimson%20and%20dark%20charcoal%20color%20palette%2C%20night%20scene%20atmosphere%20with%20soft%20ambient%20lighting%2C%20mysterious%20pap%20arazzi%20photography%20style%2C%20abstract%20blur%20motion%20effect%2C%20cinematic%20moody%20composition%2C%20no%20people%20no%20text&width=800&height=450&seq=media-4-911&orientation=landscape',
};

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-[1200px]">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 text-xs font-semibold text-secondary-700 bg-secondary-100 rounded-full mb-3">
            视觉爆料
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">独家影像</h2>
          <p className="mt-2 text-sm text-foreground-600">视频与画面还原爆料现场</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaData.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group bg-background-100 rounded-lg border border-background-200/60 overflow-hidden hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={mediaImages[item.id]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute bottom-2 left-2 px-1.5 py-0.5 bg-black/70 rounded text-[10px] text-white font-medium">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-white">
                    <i className="ri-play-fill text-lg md:text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <span className="text-[10px] font-semibold text-primary-600 bg-primary-100 px-1.5 py-0.5 rounded">
                  {item.category}
                </span>
                <h3 className="mt-2 text-sm font-semibold text-foreground-800 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <div className="mt-2 flex items-center gap-3 text-[11px] text-foreground-500">
                  <span><i className="ri-eye-line mr-0.5"></i>{item.views}</span>
                  <span>{item.date}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}